var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class AutoReload extends Component {
    constructor() {
        super('AutoReload', false);
        this.lastTime = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('body').hasClass('auto-reload')) {
                setInterval(() => __awaiter(this, void 0, void 0, function* () {
                    const response = yield $.httpRequest({
                        url: '/wp-admin/admin-ajax.php',
                        type: 'POST',
                        body: {
                            'action': 'get_assets_date'
                        },
                        dataType: 'json'
                    });
                    if (parseInt(response) != this.lastTime && this.lastTime != 0)
                        location.reload();
                    this.lastTime = parseInt(response);
                }), 2500);
            }
            this.success();
        });
    }
}
